import type { PlaceRingAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { YinshState } from "../types/game-state";
import { getCellContent, isValidPosition } from "../utils/board-utils";

export function validatePlaceRing(
  state: YinshState,
  action: PlaceRingAction,
): ValidationResult {
  if (state.phase !== "RING_PLACEMENT") {
    return { valid: false, error: "Not in ring placement phase" };
  }
  if (action.player !== state.currentPlayer) {
    return { valid: false, error: "Not your turn" };
  }
  const player = state.players.find((p) => p.color === action.player);
  if (!player || player.ringsOnBoard >= 5) {
    return { valid: false, error: "All your rings are already placed" };
  }
  if (!isValidPosition(action.position)) {
    return { valid: false, error: "Invalid board position" };
  }
  if (getCellContent(state.board, action.position) !== null) {
    return { valid: false, error: "Position is occupied" };
  }
  return { valid: true };
}
